<template>
    <div class="tm-scope tm-auth">
        <div class="tm-auth__wrap">
            <div class="tm-card tm-auth__card tm-reveal">
                <img src="../../assets/images/Logo black.png" class="tm-auth__logo" alt="Topment">
                <h3 class="mb-4">Create your account</h3>

                <div class="text-start">
                    <label class="tm-field-label" for="signup-name">Name</label>
                    <input id="signup-name" type="text" class="tm-field mb-3" v-model="name">

                    <label class="tm-field-label" for="signup-email">Email</label>
                    <input id="signup-email" type="email" class="tm-field mb-3" v-model="email">

                    <label class="tm-field-label" for="signup-password">Password</label>
                    <input id="signup-password" type="password" class="tm-field" v-model="password">

                    <div class="tm-auth__check">
                        <input id="signup-privacy" type="checkbox" v-model="privacy_policy">
                        <label for="signup-privacy" class="tm-muted" style="font-size: 0.85rem;">
                            I accept the <a href="#" @click.prevent="router.push({name:'privacy-policy'})">privacy policy</a>
                        </label>
                    </div>

                    <div v-if="error" class="text-danger mt-2" style="font-size: 0.85rem;">{{ error }}</div>
                </div>

                <button class="tm-btn-primary w-100 mt-4" :disabled="loading" @click="signup()">
                    <Spinner v-if="loading" :size="16" />
                    <span v-else>Sign up</span>
                </button>

                <div class="tm-auth__foot">
                    Already have an account?
                    <a class="tm-auth__link" @click="router.push({name:'signin'})">Sign in</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { AuthApiService } from '@/services/AuthApiService';
import Spinner from '@/components/Spinner.vue';

export default defineComponent({
    components: {
        Spinner,
    },
    setup() {
        const router = useRouter()
        const email = ref()
        const name = ref()
        const password = ref()
        const privacy_policy = ref()
        const error = ref()
        const loading = ref(false)

        function signup() {
            if (name.value && email.value && password.value && privacy_policy.value) {
                error.value = ''
                loading.value = true
                AuthApiService.signup(email.value,password.value,name.value).then((res)=>{
                    if (res.status==200) {
                        router.push({'name':'signin'})
                    }
                }).catch((err)=>{
                    if (err.status==409) {
                        error.value = 'This email or username has already been registered'
                    }
                    else {
                        error.value = 'Something went wrong. Please try again.'
                    }
                }).finally(()=>{
                    loading.value = false
                })
            }
            else if (!privacy_policy.value) {
                error.value = 'Please accept the privacy policy to continue'
            }
            else {
                error.value = 'Please fill in all the values'
            }
        }

        return {
            router,
            email,
            password,
            name,
            error,
            loading,
            privacy_policy,
            signup
        }
    },
})
</script>
<style lang="scss" scoped>
.tm-auth {
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.tm-auth__wrap {
    width: 100%;
    max-width: 420px;
}

.tm-auth__card {
    text-align: center;
    padding: 40px;
}

.tm-auth__logo {
    width: 100px;
    margin: 0 auto 20px;
    display: block;
}




.tm-auth__check {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 14px;
}

.tm-auth__check input {
    margin-top: 3px;
}

.tm-auth__foot {
    margin-top: 20px;
    font-size: 0.88rem;
    color: var(--tm-ink-muted);
}

.tm-auth__link {
    color: var(--tm-ink);
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;
}
</style>
